import { sourceOptions } from './formatSource';

const getCreatedByText = ({ createdBy, createdByFullName, source }) => {
  let createdByText = 'Customer';

  // Booking created by a known user (based on internalId)
  const hasCreatorName = createdBy?.firstName || createdBy?.lastName;

  if (hasCreatorName) {
    // Booking created by an RSA, or by a customer via an RSA internal ID.
    createdByText = createdByFullName || 'Customer';
  } else if (source === sourceOptions.PROTRACTOR) {
    createdByText = 'In shop';
  }

  return createdByText;
};

export default getCreatedByText;
